/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const h = 'is-hidden';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_thin" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_thin" /></svg></button>';

	// ===========================================================================
	// さらに表示する
	const sortMore = () => {
		const moreBtn = $('.js-sortMore');
		if(moreBtn.length) {

			// タグが2件までの場合は「さらに表示する」を非表示
			if($('input.js-check').length <= 2) {
				moreBtn.addClass(h);
			}

			moreBtn.on('click', (e) => {
				moreBtn.addClass(h);
				$('.journal-sort-body-inner').addClass(v);
			});
		}
	};
	// 年号プルダウン
	const yearSelect = () => {
		// 年号プルダウン
		const selectYear = $('.js-select-year');
		if(selectYear.length) {
			let latestY = $('.js-news-latest-year').text();
			let oldestY = $('.js-news-earliest-year').text();
			let yearArr = [];
			let selectedY = '';
			// 年号セレクトボックス生成
			for(let i = latestY; i > oldestY-1; i--) {
				yearArr.push(Number(i));
				if(location.pathname.indexOf(i) !== -1) {
					selectYear.append(`<option value="${i}" selected="selected">${i}年</option>`);
					selectedY = i;
				} else {
					selectYear.append(`<option value="${i}">${i}年</option>`);
				}
			}
			// 年号プルダウンチェンジ
			selectYear.on('change', (e) => {
				let thisY = $(e.currentTarget).val();
				let param = location.search;
				if(location.pathname.indexOf('/journal/') !== -1) {
					// KONOIKEジャーナル
					if(thisY === '') {
						location.href = '/journal/'+ param ;
					} else {
						location.href = '/journal/'+ thisY +'/'+ param;
					}
				} else if(location.pathname.indexOf('/story/') !== -1) {
					// プロジェクトストーリー
					if(thisY === '') {
						location.href = '/story/'+ param;
					} else {
						location.href = '/story/'+ thisY +'/'+ param;
					}
				}

			});
		}
	}
	// タグ絞り込み
	const sortTag = () => {
		if($('.js-check').length) {
			let url = new URL(window.location.href);
			let tagArr = url.searchParams.getAll('p_tags');

			let headerH = $(window).width() > 1024 ? 90 : 60;

			for(let i = 0; i < tagArr.length; i++) {
				$('.js-check[value="'+ tagArr[i] +'"]').prop('checked', true);
			}
			// チェックボックスクリック時
			$('.js-check').on('change', (e) => {
				url.searchParams.delete('tags_reset');
				url.searchParams.delete('rt_bn_journal_list_skip'); // ページャー用のパラメータを削除

				let thisVal = $(e.currentTarget).val();
				if(tagArr.indexOf(thisVal) !== -1) {					
					url.searchParams.delete('p_tags');
					for(let i = 0; i < tagArr.length; i++) {
						if(tagArr[i] !== thisVal) {
							url.searchParams.append('p_tags', tagArr[i]);	
						}
					}
				} else {
					url.searchParams.append('p_tags', thisVal);
				}
				location.href = url;
			});


			// リセット
			$('.js-search-reset').on('click', (e) => {
				$(e.currentTarget).parents('.js-toggleBlock').find('.mod-check-input').prop('checked', false);
				url.searchParams.append('tags_reset', true); // 「リセットする」ボタンからの遷移か識別するようのパラメータ
				url.searchParams.delete('p_tags');
				location.href = url;
			});

			// 絞り込み時orリセット時
			if(url.searchParams.has('p_tags') || url.searchParams.has('tags_reset')) {
				$(document).ready(() => {
					const target = document.querySelector('#result');
					const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerH;
					window.scrollTo({
						top: targetPosition,
						behavior: 'auto'
					});

					$('.header').addClass('is-move');
					$('#result .js-sort-toggle').addClass(a);
					$('#result .js-toggleBlock').slideToggle();
				})
			}
		}
	};

	// ==============================================================================
	sortMore();
	yearSelect();
	sortTag();

})(window.jQuery, window.KONOIKE);
